import { oncallFetch } from "sc/backend/oncall/fetch-helper";

export default function*(
  name,
  administrative,
  defaultShiftChangeTime,
  enabled,
  timeZone,
  defaultShiftDays,
) {
  return yield oncallFetch("/api/oncall/partners/regions/add", {
    name,
    administrative,
    defaultShiftChangeTime,
    enabled,
    timeZone,
    defaultShiftDays,
  });
}



// WEBPACK FOOTER //
// ./src/sc/backend/oncall/partners/regions/add.js